/**Dependencies */
import React, { useEffect, useState } from "react";

/**Styles */
import "../styles/components/checkOutCart.scss";

/**Images */
import iconCart from "../images/iconCart.png";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

export const CheckOutCart = ({
  arrDatos,
  setAlert,
  showAlert,
  setAlertMessage,
  isCheckedBackTraslado,
}) => {
  const [totalReserva, setTotalReserva] = useState(0);
  const location = useLocation();
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  // Función para calcular el total de reservas
  const calcularTotalReservas = () => {
    const actividades = arrDatos?.actividades || [];
    const hospedaje = arrDatos?.hospedaje || [];
    const traslados = arrDatos?.traslados || [];

    return (
      (actividades?.length > 0 ? actividades?.length : 0) +
      (hospedaje?.length > 0 ? hospedaje?.length : 0) +
      (traslados?.length > 0 ? traslados?.length : 0)
    );
  };

  useEffect(() => {
    // Actualizar el total al montar el componente
    setTotalReserva(calcularTotalReservas());

    // Escuchar eventos de actualización del carrito
    const handleCartUpdate = () => {
      const datos = JSON.parse(sessionStorage.getItem("datosReserva"));
      if (datos) {
        const newTotal =
          (datos?.hospedaje?.length || 0) +
          (datos?.actividades?.length || 0) +
          (datos?.traslados?.length || 0);
        setTotalReserva(newTotal);
      }
    };

    // Escuchar eventos personalizados y de storage
    window.addEventListener("cartUpdated", handleCartUpdate);
    window.addEventListener("storage", handleCartUpdate);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("storage", handleCartUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrDatos, location]);

  /**
   * Este useEffect se encarga de mostrar un mensaje de alerta cuando se actualiza el carrito.
   */
  useEffect(() => {
    if (showAlert) {
      if (totalReserva > 0) {
        setMessage(setAlertMessage);
        setAlert(false);
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
        const timeoutId = setTimeout(() => {
          setMessage("");
        }, 1500);

        return () => clearTimeout(timeoutId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrDatos, totalReserva, location.pathname]);

  /** Función para manejar el clic en el carrito cuando es el listado de resultado de traslados */
  const handleClickPreventa = () => {
    if (isCheckedBackTraslado && arrDatos?.traslados?.length === 1) {
      Swal.fire({
        title:
          "Debes de agregar tu traslado de salida antes de ir a la preventa.",
        icon: "warning",
        showCancelButton: false,
        showConfirmButton: false,
      });
      return;
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      navigate("/preventa");
    }
  };
  return (
    <div className="float-cart">
      {message && (
        <div className={"alertCart"}>
          <span>{message}</span>
        </div>
      )}
      <div>
        <span className={"countCart"}>{totalReserva}</span>
        <Button
          className="bg-transparent border-0 p-0"
          onClick={handleClickPreventa}
          rel="noreferrer"
        >
          <img src={iconCart} alt="Carrito" className="cart-icon" />
        </Button>
      </div>
    </div>
  );
};
